import { compact } from 'lodash';
import { UserPlain } from '../../iam/users/types';

export interface Comment {
  id: number;
  targetType: CommentTargetType;
  targetId: string;
  text: string;
  user?: UserPlain;
  createdAt?: string;
  updatedAt?: string;
}

export enum CommentTargetType {
  COMPANY = 'COMPANY',
  COMPANY_DESCRIPTION = 'COMPANY_DESCRIPTION',
  COMPANY_PRODUCT_SET = 'COMPANY_PRODUCT_SET',
  COMPANY_REVENUE = 'COMPANY_REVENUE',
  COMPANY_INCOME = 'COMPANY_INCOME',
  COMPANY_EMPLOYEE_COUNT = 'COMPANY_EMPLOYEE_COUNT',
  COMPANY_GROUP = 'COMPANY_GROUP',
  PORTFOLIO = 'PORTFOLIO',
  PRODUCT = 'PRODUCT',
  PRODUCT_MARKET_SIZE = 'PRODUCT_MARKET_SIZE',
  PRODUCT_PHRASE_TAG = 'PRODUCT_PHRASE_TAG',
  CONSTRAINT_SET = 'CONSTRAINT_SET',
  ENTITY_QUALITY_CHECK = 'ENTITY_QUALITY_CHECK',
  BLANKET_PRODUCT_SET = 'BLANKET_PRODUCT_SET',
}

export const allCommentTargetTypes: CommentTargetType[] = compact(
  Object.values(CommentTargetType).map(v => {
    if (typeof v !== 'string') {
      return undefined;
    }
    return v;
  }),
);

export function isCommentTargetType(type: string): type is CommentTargetType {
  return allCommentTargetTypes.indexOf(type as CommentTargetType) > -1;
}
